import { handleErrors, paginatedRequestWithBody, simpleDeleteRequestWithBody, simpleGetRequest, simplePostRequestWithBody } from "../../../shared/src/API/baseAPI";
import { createUserCard } from "../../../shared/src/components/UserCard/user-info";
import eventBus from "../../../shared/src/events/eventBus";
import { showAlert } from "../../../shared/src/Util/alerts";
import { setupTranslator } from "../../../shared/src/Util/translation";
import { parseCustomMarkdown } from "./editor";

document.addEventListener('DOMContentLoaded', () => {
    displayLike();
    if (post.comments && Array.isArray(post.comments) && post.comments.length > 0) {
        document.getElementById('noComments').style.display = 'none';
        post.comments.forEach(comment => {
            displayComment(comment);
        });
    }

    eventBus.on('translation:setup', ({ elementId }) => {
        if (elementId !== 'blog-post') {
            return;
        }
        requestAnimationFrame(() => {
            document.getElementById(elementId).innerHTML = parseCustomMarkdown(document.getElementById(elementId).innerHTML, elementId);
        });
    });

    eventBus.on('translation:switched', ({ to, elementId }) => {
        if (elementId !== 'blog-post') {
            return;
        }
        document.getElementById(elementId).innerHTML = parseCustomMarkdown(document.getElementById(elementId).innerHTML, elementId);
    });
    setupTranslator(post.content, 'blog-post');
});

export function toggleLike() {
    simplePostRequestWithBody('/api/v1/blog/' + post.id + '/like', { like: !isLiked }, 'likePostBtn', handleLike);
}

function handleLike(res) {
    if (res.error) {
        handleErrors(res);
        return;
    }

    isLiked = res.like;
    post.likeCount = res.likeCount;
    displayLike();
}

function displayLike() {
    if (isLiked) {
        document.getElementById('like-icon').classList.add('text-primary');
        document.getElementById('likePostBtn').innerHTML = '<i class="fa-solid fa-heart-crack"></i> Unlike post';
    } else {
        document.getElementById('like-icon').classList.remove('text-primary');
        document.getElementById('likePostBtn').innerHTML = '<i class="fa-solid fa-heart"></i> Like post';
    }
    document.getElementById('like-count').innerHTML = post.likeCount;
}

let replyCommentId = null

export function submitComment(event) {
    event.preventDefault();
    const formData = new FormData(event.target);
    const content = formData.get('content');

    if (!content || content == "") {
        showAlert(t('comments.noComment'), 'error');
        return;
    }

    if (content.length > 500) {
        showAlert(t('comments.tooLong'), 'error');
        return;
    }

    simplePostRequestWithBody(`/api/v1/blog/${post.id}/comments`, { content, parent: replyCommentId }, 'addCommentBtn', handleCommentSubmission);
}

function handleCommentSubmission(res) {
    if (res.error) {
        handleErrors(res);
        return;
    }

    if (replyCommentId && res.type == 'reply') {
        cancelReply();
    } else if (res.type == 'comment') {
        document.getElementById('comment-form').reset();
    }

    updateComment(res.comment.id, res.comment.content, false, res.comment.parentId);
    document.getElementById('comment-count').innerText = Number(document.getElementById('comment-count').innerText) + 1;
    document.getElementById('noComments').style.display = 'none';
}

function deleteComment(commentId) {
    simpleDeleteRequestWithBody(`/api/v1/blog/${post.id}/comments`, {commentId}, `delete-comment-${commentId}`, handleCommentDeletion);
}

function handleCommentDeletion(res) {
    if (res.error) {
        handleErrors(res);
        return;
    }

    const commentDiv = document.getElementById('comment-' + res.commentId);
    if (commentDiv) {
        commentDiv.remove();
        document.getElementById('comment-count').innerText = Number(document.getElementById('comment-count').innerText) - 1;
        if (Number(document.getElementById('comment-count').innerText) === 0) {
            document.getElementById('noComments').style.display = 'block';
        }
    }
}

function updateComment(commentId, content, isLiked, parentId, edited = false) {
    const comment = post.comments.find(c => c.id === commentId);
    if (comment) {
        if (content) {
            comment.content = content;
        }
        if (isLiked != undefined && comment.likedByUser != isLiked) {
            comment.likedByUser = isLiked;
            comment.likeCount = isLiked ? (comment.likeCount || 0) + 1 : Math.max((comment.likeCount || 1) - 1, 0);
        }
        if (edited) {
            comment.updatedAt = new Date().toISOString();
        }
    } else {
        post.comments.push({ id: commentId, content, likedByUser: false, likeCount: 0, user: alertUser, userId: alertUser.id, createdAt: new Date().toISOString(), updatedAt: edited? undefined : new Date().toISOString(), parentId, replyCount: 0 });
    }

    displayComment(post.comments.find(c => c.id === commentId));
}

function toggleCommentLike(commentId) {
    const comment = post.comments.find(c => c.id === commentId);
    if (comment) {
        likeComment(commentId, 'like', comment.likedByUser);
    }
}

function likeComment(commentId, reaction, isLiked) {
    simplePostRequestWithBody(`/api/v1/blog/${post.id}/comments/like`, { commentId, reaction, isLiked }, `like-comment-${commentId}`, handleCommentLike)
}

function handleCommentLike(res) {
    if (res.error) {
        handleErrors(res);
        return;
    }

    updateComment(res.commentId, undefined, res.like);
}

export function getComments() {
    simpleGetRequest(`/api/v1/blog/${post.id}/comments`, 'commentsContainer', handleComments);
}

function getReplies(commentId) {
    paginatedRequestWithBody(`/api/v1/blog/${post.id}/comments/${commentId}/replies`, {}, `replies-loader-${commentId}`, handleComments);
}

function handleComments(res) {
    if (res.error) {
        handleErrors(res);
        return;
    }

    if (!res.comments || !Array.isArray(res.comments) || res.comments.length === 0) {
        if (res.type === 'comments') {
            document.getElementById('noComments').style.display = 'block';
        }
        if (res.type === 'replies') {
            const parentId = res.parentId;
            const repliesLoader = document.getElementById('replies-loader-' + parentId);
            if (repliesLoader) {
                repliesLoader.remove();
            }
        }
        return;
    }

    if (res.type === 'replies') {
        const parent = post.comments.find(c => c.id === res.parentId);
        if (parent) {
            parent.replyCount = Math.max((parent.replyCount || 1) - res.comments.length, 0);

            if (parent.replyCount === 0) {
                const repliesLoader = document.getElementById('replies-loader-' + res.parentId);
                if (repliesLoader) {
                    repliesLoader.remove();
                }
            } else {
                document.getElementById('replies-loader-' + res.parentId).innerHTML = `<i class="fa-solid fa-chevron-down"></i>${parent.replyCount} ${t('comments.replies')}`;
            }
        }
    }
    post.comments = post.comments.concat(res.comments);
    res.comments.forEach(comment => {
        displayComment(comment);
    });
}

export function getLink() {
    App.common.copyLink(window.location.href, 'copy-link-btn', 'blog', post.title, post.excerpt ? post.excerpt : "");
}

function displayComment(comment) {
    const commentDiv = document.getElementById('comment-' + comment.id) || document.createElement('div');
    const createNew = commentDiv.id === '';
    commentDiv.id = `comment-${comment.id}`;
    
    if (createNew) {
        const flexContainer = document.createElement('div');
        flexContainer
        
        const userCardContainer = document.createElement('div');
        createUserCard(userCardContainer, comment.user, {
            date: comment.createdAt,
            show: {
                avatar: true,
                name: true,
                hover: true
            },
            size: 'w-10 h-10',
            position: 'bottom-right'
        });

        const contentDiv = document.createElement('div');
        contentDiv.id = `comment-content-${comment.id}`;
        contentDiv.className = 'flex-1';
        
        const actionsDiv = document.createElement('div');
        actionsDiv.className = 'flex items-center gap-1 ml-auto';

        const likeBtn = document.createElement('button');
        likeBtn.className = `btn btn-ghost ${comment.likedByUser ? 'text-error' : ''}`;
        likeBtn.id = `like-comment-${comment.id}`;
        likeBtn.innerHTML = `
            <i class="fas fa-heart ${comment.likedByUser ? 'text-error' : ''}"></i>
            <span class="like-count">${comment.likeCount || 0 }</span>
        `;
        likeBtn.title = comment.likedByUser ? 'Unlike' : 'Like';
        likeBtn.addEventListener('click', () => likeComment(comment.id, 'like', comment.likedByUser));
        actionsDiv.appendChild(likeBtn);
        
        const dropdown = document.createElement('div');
        dropdown.className = 'dropdown dropdown-end';
        
        const dropdownBtn = document.createElement('div');
        dropdownBtn.setAttribute('tabindex', '0');
        dropdownBtn.setAttribute('role', 'button');
        dropdownBtn.className = 'btn btn-ghost';
        dropdownBtn.innerHTML = '<i class="fas fa-ellipsis-v"></i>';
        
        const dropdownContent = document.createElement('ul');
        dropdownContent.setAttribute('tabindex', '0');
        dropdownContent.className = 'dropdown-content z-[1] menu p-2 shadow bg-base-100 rounded-box w-52';

        dropdown.appendChild(dropdownBtn);
        dropdown.appendChild(dropdownContent);
        actionsDiv.appendChild(dropdown);
        
        if (alertUser && alertUser.id === comment.userId) {
            const editItem = document.createElement('li');
            const editLink = document.createElement('a');
            editLink.innerHTML = `<i class="fas fa-edit"></i> ${t('u.edit')}`;
            editLink.addEventListener('click', () => editComment(comment.id));
            editItem.appendChild(editLink);
            dropdownContent.appendChild(editItem);
        }

        if (alertUser) {
            const toggleLikeItem = document.createElement('li');
            const toggleLike = document.createElement('a');
            toggleLike.innerHTML = comment.likedByUser? `<i class="fas fa-heart-crack"></i> ${t('u.unlike')}` : `<i class="fas fa-heart"></i> ${t('u.like')}`;
            toggleLike.id = `toggle-like-comment-${comment.id}`;
            toggleLike.onclick = () => toggleCommentLike(comment.id);
            toggleLikeItem.appendChild(toggleLike);
            dropdownContent.appendChild(toggleLikeItem);
        }

        if (alertUser) {
            const replyItem = document.createElement('li');
            const replyLink = document.createElement('a');
            replyLink.innerHTML = `<i class="fas fa-reply"></i> ${t('comments.reply')}`;
            replyLink.addEventListener('click', () => replyToComment(comment.id));
            replyItem.appendChild(replyLink);
            dropdownContent.appendChild(replyItem);
        }
        
        if (!alertUser || alertUser.id !== comment.userId) {
            const reportBtn = document.createElement('li');
            reportBtn.id = `report-btn-${comment.id}`;
            reportBtn.innerHTML = `<a><i class="fas fa-flag"></i> ${t('u.report')}</a>`;
            reportBtn.title = 'Report';
            reportBtn.onclick = () => App.common.reportUser(comment.user.id, comment.user.username);
            dropdownContent.appendChild(reportBtn);
        }
        
        if (alertUser && (alertUser.id === comment.userId || (alertUser.types && alertUser.types.includes('Admin')))) {
            const deleteItem = document.createElement('li');
            const deleteLink = document.createElement('a');
            deleteLink.innerHTML = `<i class="fas fa-trash text-error"></i> ${t('u.delete')}`;
            deleteLink.addEventListener('click', () => deleteComment(comment.id));
            deleteItem.appendChild(deleteLink);
            dropdownContent.appendChild(deleteItem);
        }

        const headerDiv = document.createElement('div');
        headerDiv.className = 'flex items-start gap-4';
        headerDiv.appendChild(userCardContainer);
        headerDiv.appendChild(actionsDiv);
        contentDiv.appendChild(headerDiv);
        
        const contentP = document.createElement('p');
        contentP.className = 'text-base-content/90 leading-relaxed';
        contentP.id = `comment-text-${comment.id}`;

        if (new Date(comment.createdAt).getTime() != new Date(comment.updatedAt).getTime()) {
            const editedSpan = document.createElement('span');
            editedSpan.className = 'text-sm text-base-content/50 ml-2';
            editedSpan.textContent = ` (edited)`;
            contentP.appendChild(editedSpan);
        }

        contentDiv.appendChild(contentP);
        commentDiv.appendChild(contentDiv);
        
        if (comment.parentId) {
            commentDiv.classList.add('ml-4', 'mt-4', 'pl-4', 'border-l-4', 'border-secondary');
            const parentComment = document.getElementById('comment-content-' + comment.parentId).insertBefore(commentDiv, document.getElementById('replies-loader-' + comment.parentId));
        } else {
            document.getElementById('comments-container').appendChild(commentDiv);
            commentDiv.className = 'comment mb-6 p-4 bg-base-100 rounded-lg shadow-sm border-l-4 border-primary';
        }

        if (comment.replyCount && comment.replyCount > 0 && comment.parentId == null) {
            const repliesCount = document.createElement('div');
            repliesCount.className = 'text-sm text-base-content/60 mt-2 cursor-pointer';
            repliesCount.innerHTML = `<i class="fa-solid fa-chevron-down"></i>${comment.replyCount} ${t('comments.replies')}`;
            repliesCount.id = `replies-loader-${comment.id}`;
            repliesCount.onclick = () => getReplies(comment.id);
            contentDiv.appendChild(repliesCount);
        }
    } else {
        const likeBtn = document.getElementById(`like-comment-${comment.id}`);
        if (likeBtn) {
            likeBtn.className = `btn btn-ghost ${comment.likedByUser ? 'text-error' : ''}`;
            likeBtn.title = comment.likedByUser ? t('u.unlike') : t('u.like');
            likeBtn.innerHTML = `
                <i class="fas fa-heart ${comment.likedByUser ? 'text-error' : ''}"></i>
                <span class="like-count">${comment.likeCount || 0 }</span>
            `;
        }

        const toggleLike = document.getElementById(`toggle-like-comment-${comment.id}`);
        if (toggleLike) {
            toggleLike.innerHTML = comment.likedByUser? `<i class="fas fa-heart-crack"></i> ${t('u.unlike')}` : `<i class="fas fa-heart"></i> ${t('u.like')}`;
        }
    }

    const contentP = document.getElementById(`comment-text-${comment.id}`);
    if (contentP) {
        if (comment.userId === alertUser?.id) {
            contentP.textContent = comment.content[comment.content.original? comment.content.original : locale] || comment.content.en || comment.content.de;
        } else {
            setupTranslator(comment.content, `comment-text-${comment.id}`);
        }

        if (new Date(comment.createdAt).getTime() != new Date(comment.updatedAt).getTime()) {
            const editedSpan = document.createElement('span');
            editedSpan.className = 'text-sm text-base-content/50 ml-2';
            editedSpan.textContent = ` (${t('u.edited')})`;
            contentP.appendChild(editedSpan);
        }
    }
}

let editingCommentId = null;

function editComment(commentId) {
    const comment = post.comments.find(c => c.id === commentId);
    if (!comment) return;

    if (editingCommentId) {
        cancelEdit(editingCommentId);
    }

    editingCommentId = commentId;
    const commentDiv = document.getElementById(`comment-${commentId}`);
    const contentP = document.getElementById(`comment-text-${commentId}`);
    let originalContent = comment.content[comment.content.original? comment.content.original : locale] || comment.content.en || comment.content.de;

    if (originalContent.endsWith(`(${t('translations.translated')})`)) {
        originalContent = originalContent.slice(0, -(` (${t('translations.translated')})`.length -1)).trim();
    }

    if (originalContent.endsWith(`(${t("u.edited")})`)) {
        originalContent = originalContent.slice(0, -(` (${t("u.edited")})`.length -1)).trim();
    }

    const editForm = document.createElement('form');
    editForm.className = 'mt-2';
    editForm.innerHTML = `
        <div class="form-control">
            <textarea class="textarea textarea-bordered w-full" name="content">${originalContent}</textarea>
            <div class="flex justify-end gap-2 mt-2">
                <button type="button" class="btn btn-ghost btn-sm" onclick="App.blog.cancelEdit(${commentId})">
                    <i class="fas fa-times"></i> ${t('u.cancel')}
                </button>
                <button type="submit" class="btn btn-primary btn-sm" id="save-edit-${commentId}">
                    <i class="fas fa-save"></i> ${t('u.save')}
                </button>
            </div>
        </div>
    `;

    editForm.onsubmit = (e) => {
        e.preventDefault();
        const formData = new FormData(e.target);
        saveEdit(commentId, formData.get('content'));
    };

    contentP.replaceWith(editForm);
    const textarea = editForm.querySelector('textarea');
    textarea.focus();
    textarea.setSelectionRange(originalContent.length, originalContent.length);
}

export function cancelEdit(commentId) {
    const comment = post.comments.find(c => c.id === commentId);
    if (!comment) return;

    const commentDiv = document.getElementById(`comment-${commentId}`);
    const editForm = commentDiv.querySelector('form');
    if (!editForm) return;

    const contentP = document.createElement('p');
    contentP.className = 'text-base-content/90 leading-relaxed';
    contentP.textContent = comment.content[comment.content.original? comment.content.original : locale] || comment.content.en || comment.content.de;
    editForm.replaceWith(contentP);
    editingCommentId = null;
}

function saveEdit(commentId, newContent) {
    if (!newContent || newContent.trim() === '') {
        showAlert(`${t("comments.noComment")}`, 'error');
        return;
    }

    simplePostRequestWithBody(
        `/api/v1/blog/${post.id}/comments/edit`,
        { commentId, content: newContent },
        `save-edit-${commentId}`,
        handleEditSubmission
    );
}

function handleEditSubmission(res) {
    if (res.error) {
        handleErrors(res);
        return;
    }

    updateComment(res.comment.id, res.comment.content, undefined, res.comment.parentId, true);
    cancelEdit(editingCommentId);
    editingCommentId = null;
}

function replyToComment(commentId) {
    const existingReplyForm = document.querySelector('.reply-form');
    if (existingReplyForm) {
        existingReplyForm.remove();
        if (replyCommentId === commentId) {
            replyCommentId = null;
            return;
        }
    }

    replyCommentId = commentId;
    const comment = post.comments.find(c => c.id === commentId);
    if (!comment) return;

    if (comment.parentId) {
        replyCommentId = comment.parentId;
    }

    const commentDiv = document.getElementById(`comment-${commentId}`);
    
    const replyForm = document.createElement('form');
    replyForm.className = 'reply-form mt-4 ml-12';
    replyForm.innerHTML = `
        <div class="form-control">
            <div class="flex gap-2">
                <input class="input input-bordered flex-1" 
                    name="content" 
                    placeholder="${t('comments.replyPlaceholder')}"
                    required>
                <button type="submit" class="btn btn-primary" id="reply-btn-${commentId}">
                    <i class="fas fa-reply"></i> ${t('comments.reply')}
                </button>
                <button type="button" class="btn btn-ghost" onclick="App.blog.cancelReply()">
                    <i class="fas fa-times"></i>
                </button>
            </div>
        </div>
    `;

    replyForm.onsubmit = submitComment;
    commentDiv.appendChild(replyForm);
    const input = replyForm.querySelector('input[name="content"]');
    input.focus();
    input.setSelectionRange(0, 0);
}

export function cancelReply() {
    const replyForm = document.querySelector('.reply-form');
    if (replyForm) {
        replyForm.remove();
        replyCommentId = null;
    }
}